function Footer(){
  return (
    <div className="footer">
      <p className="textright">Last updated 2/4/2026</p>
    </div>)
}

export default Footer
;
